import React, { useState, useEffect } from 'react'

export default LookupForm = ({ serial, setSerial, setMode, setResult }) => {
  const [lookupResult, setLookupResult] = useState({})
  const [btnText, setBtnText] = useState(wck_app.check_button_field)
  const [isDisabled, setIsDisabled] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (
      lookupResult.do_registeration === true &&
      lookupResult.status === 'ok'
    ) {
      setMode('Register')
      setResult(lookupResult.msg)
    } else if (lookupResult.do_registeration === false) {
      setMode('ShowResult')
      setResult(lookupResult)
    }
  }, [lookupResult])

  const handleLookup = (e) => {
    e.preventDefault()
    setBtnText('')
    setIsLoading(true)
    const handleFetch = fetch(wck_app.handle_uri, {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'include',
      cache: 'no-cache',
      headers: new Headers({
        Accept: 'application/json',
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }),
      body: `action=wck_lookup&serial=${serial}`,
    })
      .then((data) => data.json())
      .catch((e) => `رد شد: ${e}`)
    handleFetch.then((res) => {
      setLookupResult({ ...res })
      setIsLoading(false)
      setBtnText('بررسی')
    })
  }
  return (
    <div className='warranty-wrapper'>
      <form onSubmit={(e) => handleLookup(e)} method='post'>
        <label htmlFor='serial'>{wck_app.serial_field}</label>
        <input
          type='text'
          name='serial'
          onChange={(e) => setSerial(e.target.value)}
          required
        />
        <button
          type='submit'
          id='lookup_btn'
          disabled={isDisabled}
          className='btn btn-indigo'
        >
          {btnText}
          {isLoading && (
            <svg
              id='registering'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
            >
              <circle
                className='opacity-25'
                cx='12'
                cy='12'
                r='10'
                stroke='currentColor'
                strokeWidth='4'
              ></circle>
              <path
                className='opacity-75'
                fill='currentColor'
                d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
              ></path>
            </svg>
          )}
        </button>
      </form>
    </div>
  )
}
